import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DocumentIcon } from '../../../../../assets/images/document.svg';

import styles from './MappingSummary.module.scss';

const MappingSummary = ({ file, sample }) => {
  const { t } = useTranslation('common');
  return (
    <div>
      <p className={styles.heading}>{t('csvImport.mappingSummary')}</p>
      <p className={styles.text}>{t('csvImport.sampleSetup')}</p>
      <div className={styles.fileCont}>
        <DocumentIcon />
        <p className={styles.fileName}>{file.name}</p>
      </div>
      <div className={styles.headerCont}>
        <p className={styles.header}>{t('csvImport.sample')}</p>
      </div>
      <div className={styles.summaryCont}>
        <div className={styles.elCont}>
          <div className={styles.col1}>
            <p className={styles.boonHeading}>{t('csvImport.boonValue')}</p>
          </div>
          <div className={styles.col2}>
            <p className={styles.importHeading}>{t('csvImport.importedValue')}</p>
          </div>
        </div>
        {sample.map((data) => (
          <div className={styles.elCont} key={data[0] + data[1]}>
            <div className={styles.col1}>
              <p className={styles.boonValue}>{data[0].replace('*', '')}</p>
            </div>
            <div className={styles.col2}>
              <p className={styles.importValue}>{data[1]}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MappingSummary;
